import React, { useEffect, useReducer, useState, useRef, useImperativeHandle, forwardRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { useSelector } from 'react-redux';
import { chatReducer, initialState } from './reducer';
import { updateChat } from './Services/updateChat';
import { getMessages } from './Services/getMessages';
import { getGroupMembersList } from './Services/getGroupMembersList';
import { getGroupMembersEmail } from './Services/getGroupMembersEmail';
import * as actions from './actions';
import { isLoaded, isLoading } from '../Actions/loading';
import API from '../Network/API';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
// import RootLoader from '../Loader/RootLoad';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";
import "../vendor/doka.min.css";
import { create } from "../vendor/doka.esm.min";
import convertPSTtoLocalTime from '../convertPSTtoLocalTime';
import { useWebProperties } from '../webProperties';
import { getSubStringId } from '../SubStringConvert';
// import JitsiComponent from '../Jitsi';
import { Resizable } from 're-resizable';
import Draggable from 'react-draggable';
import { isMobile } from 'react-device-detect';
import { Meet_URL } from '../config';
import { removeSpecialCharacters } from '../commonUsage';
import jwt from 'jsonwebtoken';
import { Element, scroller } from "react-scroll";
import Highlighter from "react-highlight-words";
import { logEntry } from '../logEntry';
import DelegateTask from '../TasksModals/delegateTask';
import Alert from '../Alert';
// Register the plugins
registerPlugin(FilePondPluginImageEdit, FilePondPluginImagePreview, FilePondPluginImageExifOrientation,
    FilePondPluginFileValidateType, FilePondPluginImageResize, FilePondPluginImageTransform)


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        width: '100%', // Adjust as needed, or use '100%' for full width
        // maxWidth: 600, // Set a maximum width if needed
        // padding: theme.spacing(3), // Adjust spacing as needed
    },
}));


export default forwardRef(function MainTaskChatBox(props, ref) {

    const classNames = useStyles();
    const getUser = useSelector(state => state.auth)
    const [state, dispatch] = useReducer(chatReducer, initialState)
    const { CHATAPI, MAINTASK, ATTACH_FILE, role_array, LIMITED_ACCESS_CONTRIBUTOR } = useWebProperties();
    const [chat, setChat] = useState(0);
    const [copyfile, setCopyFile] = useState({});
    const [docFile, setDocFile] = useState({});
    const [commentDetails, setCommentDetails] = useState({});
    const [handleHover, setHandleHover] = useState(false);
    const [disable, setDisable] = useState(false);
    const [taskMeetingUrl, setTaskMeetingUrl] = useState(null)
    const [groupTask, setGroupTask] = useState([])
    const projectId = props.data.project_id ? props.data.project_id : getUser.user.projectId;
    const project_name = props.data.project_name ? props.data.project_name : getUser.user.corp;
    const [showAllNames, setShowAllNames] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null)

    // Expose refresh method to parent component
    useImperativeHandle(ref, () => ({
        refreshChatData: async () => {
            // Refresh both task data (assigned_to, assigned_by) and messages
            getGroupMembersList(dispatch, getUser.user, props.data);
            getMessages(dispatch, getUser.user, props.data);
        }
    }), [props.data, getUser.user]);


    const [searchTerm, setSearchTerm] = useState('');
    const [showResults, setShowResults] = useState(false);
    const [highlightedMessageId, setHighlightedMessageId] = useState(null);
    const [chatActive, setchatActive] = useState(false);
    const [showList, setShowList] = useState(false);
    const [groupTaskMembers, setGroupTaskMembers] = useState([])
    const [employees, setEmployees] = useState([]);
    const [groupTaskList, setGroupTaskList] = useState([])
    const [infoUsers, setInfoUsers] = useState([]);
    const [infoOpen, setInfoOpen] = useState(false)
    const [infoMessageId, setInfoMessageId] = useState(null)
    const [delegateOpen, setDelegateOpen] = useState(false);
    const [delegateCardInfo, setDelegateCardInfo] = useState(null);

    const activities = useSelector(state => state.landingReducer.userActivities)
    const fetchTimeoutRef = useRef(null);

    const filteredGroupArray = props.data.story_type === 'group' ? state.groupList?.data?.filter(item => groupTaskMembers?.includes(item.emp_id)) : state.groupList?.data?.map(item => ({ 'full_name': item.full_name, 'emp_id': item.emp_id }));

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            setShowResults(true);
            setchatActive(true);
        }
    };

    const handleClick = (id) => {
        setHighlightedMessageId(id);
        scroller.scrollTo(`message-${id}`, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
    };

    const filteredChatData = state.taskComments.filter((item) =>
        item.message.toLowerCase().includes(searchTerm.toLowerCase())
    );
    // console.log("filtered data ::",filteredChatData);

    const clearSearch = () => {
        setSearchTerm('');
        setShowResults(false);

    };


    const handleChat = () => {
        setChat(1)
    }
    const handleChatClose = () => {
        setChat(0)
        setHideButton(false)
    }

    const handleDelegateOpen = async () => {
        try {
            // Fetch full task details from API, exactly like ConsolidatedToDo does
            const taskUsId = props.data.us_id || props.data.id;
            const response = await API.post("get_user_stories.php", {
                empId: getUser.user.empId,
                action: "mytasker_all_tasks",
                searchValue: taskUsId,
                role: getUser.user.role,
            }, {}, false);

            if (response.status === 'True' && response.data && response.data.length > 0) {
                // Find the exact matching task by us_id
                const todo = response.data.find(task => String(task.us_id) === String(taskUsId)) || response.data[0];

                // Build delegate card info exactly like ConsolidatedToDo's handleOpen("delegate", todo)
                const taskData = {
                    moduleId: todo.sprint_id,
                    moduleName: todo.sprint_desc,
                    priorityLevel: todo.priority_level,
                    projectId: todo.project_id,
                    ideaId: todo.epic_id,
                    project_name: todo.project_name,
                    projectName: todo.epic_name,
                    title: todo.story_title,
                    description: todo.story_desc,
                    taskId: todo.task_type === 'sub_task' ? todo.task_id : todo.story_id,
                    acceptanceCriteria: todo.acceptance_criteria,
                    storyPoints: todo.story_points,
                    userDetails: todo.assignedto,
                    id: todo.assignedTo,
                    targetDate: todo.target_date,
                    story_type: todo.story_type,
                    kanban_status: todo.kanban_status,
                    tasks: todo,
                    task_type: todo.task_type,
                    active_status: todo.active_status,
                    us_id: todo.us_id,
                    role: todo.role,
                    assignedBy: todo.assigned_by,
                    type: null,
                };
                setDelegateCardInfo(taskData);
                setDelegateOpen(true);
            } else {
                Alert('error', 'Unable to fetch task details for delegation');
            }
        } catch (error) {
            console.log('Error fetching task details for delegate:', error);
            Alert('error', 'Failed to fetch task details');
        }
    };

    const handleDelegateClose = () => {
        setDelegateOpen(false);
        setDelegateCardInfo(null);
        // Refresh messages to show delegation comment
        getMessages(dispatch, getUser.user, props.data);
    };

    // Cleanup effect to reset component state when modal closes
    useEffect(() => {
        if (!props.open) {
            // Reset all state when modal closes to prevent duplicate instances
            dispatch(actions.taskComments([]));
            setChat(0);
            setCommentDetails({});
            setErrorMessage(null);
            setShowResults(false);
            setSearchTerm('');
            setHighlightedMessageId(null);
            setchatActive(false);
            setDelegateOpen(false);
            setDelegateCardInfo(null);
        }
    }, [props.open]);

    useEffect(() => {
        if (!props.open) return; // Don't load data if modal is not open
        
        if (props.data.outsideApp === true && props.data.outsideApp !== undefined) {
            updateChat(props.data.sno, dispatch, props.data)
        } else {
            updateChat(props.data.sno, dispatch, getUser.user)
        }

        if (props.data.meetingUrl !== null && props.data.meetingUrl !== undefined) {
            setTaskMeetingUrl(props.data.meetingUrl)
        } else if (props.data.story_type === 'group' && props.data.main_task_id !== '0') {
            updateTaskMeetingUrl(props.data.main_task_id)
        } else {
            updateTaskMeetingUrl(props.data.id)
        }
        dispatch(actions.taskComments([]));
        getGroupMembersList(dispatch, getUser.user, props.data);
        getMessages(dispatch, getUser.user, props.data);
        getGroupMembersEmail(dispatch, getUser.user, props.data);
        // eslint-disable-next-line
    }, [props.open, props.data])


    useEffect(() => {
        if (props.data.story_type === 'group' && employees.length === 0) {
            const fetchData = async () => {
                try {
                    const response = await API.post("getUpdateSprint.php", {
                        story_us_id: props.data.main_task_id === '0' ? props.data.us_id : props.data.main_task_id,
                        action: "get_group_task_info",
                    }, {}, false);
                    if (response.status === 'True') {
                        setGroupTaskList(response.data)
                        setGroupTaskMembers(response.data.map(item => item.assigned_to));
                        if (props.data.main_task_id === '0') {
                            setGroupTask(response.data.filter(data => {
                                return data.main_task_id !== '0'
                            }).map(item => item.us_id));
                        } else {
                            if (props.data.group_task_type === 'Full') {
                                let array1 = response.data.filter(val => {
                                    return val.us_id !== props.data.us_id
                                }).map(item => item.us_id);

                                let array2 = [props.data.main_task_id]
                                setGroupTask([...array1, ...array2])
                            } else {
                                setGroupTask([props.data.main_task_id])
                            }
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            };

            fetchData();
        }
    }, [props.data, employees]);


    useEffect(() => {
        if (props.data.followUp === "Follow Up" && state.groupList.data && state.groupList.data.length > 0) {
            sendMessage(`${getUser?.user?.fullName} has requested a follow-up on this task`);
        }
        // eslint-disable-next-line
    }, [props.data, state.groupList])

    useEffect(() => {
        let isComponentMounted = true;
        
        const fetchMessages = () => {
            if (isComponentMounted && props.open) {
                getMessages(dispatch, getUser.user, props.data);
                fetchTimeoutRef.current = setTimeout(fetchMessages, 15000);
            }
        };

        if (props.open) {
            fetchMessages();
        }

        // Cleanup function to stop fetching messages on unmount or when modal closes
        return () => {
            isComponentMounted = false;
            if (fetchTimeoutRef.current) {
                clearTimeout(fetchTimeoutRef.current);
                fetchTimeoutRef.current = null;
            }
        };
        // eslint-disable-next-line
    }, [props.open]);



    const msgId = props.data.sno ? props.data.sno.map((msgId, index) => {
        return msgId.sno
    }) : null

    const modalBodyRef = useRef(null);

    useEffect(() => {
        if (props.open) {
            const scrollTimeout = setTimeout(() => {
                scrollToBottom();
            }, 1000);
            return () => clearTimeout(scrollTimeout);
        }
    }, [props.open]);

    const scrollToBottom = () => {
        if (modalBodyRef.current) {
            modalBodyRef.current.scrollTop = modalBodyRef.current.scrollHeight;
        }
    };

    const updateTaskMeetingUrl = async (us_id) => {

        const secretKey = "RALLYWETASKER";

        // Sample payload data
        const payload = {
            "context": {
                "user": {
                    "avatar": "",
                    "name": "",
                    "email": "",
                },
            },
            "aud": "jitsi",
            "iss": "23456789",
            "sub": Meet_URL,
            "room": removeSpecialCharacters(us_id),
            // "exp": 1700060038,
        };
        const generatedToken = jwt.sign(payload, secretKey);
        const meeting_url = `https://${Meet_URL}/${removeSpecialCharacters(us_id)}?jwt=${generatedToken}#jitsi_meet_external_api_id=98765432&config.startWithAudioMuted=true&config.startWithVideoMuted=true&config.autoCaptionOnRecord=true`
        try {
            // eslint-disable-next-line
            const response = await API.post("manage_userstories.php", {
                action: "updateMeetingURL",
                us_id: us_id,
                meeting_url: meeting_url
            }, {}, false);
            if (response.status === "True") {
                setTaskMeetingUrl(response.meeting_url)
            }
        } catch (error) {
            console.log(error)
        }
    }


    const sendTaskMeetingUrl = () => {
        window.open(taskMeetingUrl, "_blank")
        let message = `${getUser.user.fullName || ''} Started Meeting, to connect <a target="_blank" href='${taskMeetingUrl}'>Click Here</a>`
        // eslint-disable-next-line
        sendMeetUrl(message)
        // eslint-disable-next-line
    }

    const sendMeetUrl = async (message) => {
        let otherEmails = state.groupList.data
            ?.filter((item) => {
                return (
                    item.full_role !== 'Contributor' &&
                    item.full_role !== 'Limited Access Contributor' &&
                    item.full_role !== 'Admin'
                );
            })
            .map((item) => {
                return item.email;
            });

        let taskEmails = [];
        if (state.groupList.data && state.groupList.data.length > 0) {
            const firstDataItem = state.groupList.data[0];
            taskEmails.push(firstDataItem.assigned_to_email || '');
            taskEmails.push(firstDataItem.assigned_by_email || '');
        }

        // Combine the two arrays and remove duplicates
        let allEmails = [...taskEmails, ...otherEmails];
        let uniqueEmails = [...new Set(allEmails)];

        state.taskComments.push({
            "groupId": props.data.id,
            "message": message,
            "messagedBy": getUser.user.empId || props.data.messagedBy,
            "messagedTime": "",
            "reply_message": null,
            "reply_path": null,
            "reply_username": null,
            "path": null,
            "username": getUser.user.fullName,
            sub_group_ids: [...new Set(groupTask)]
        });

        dispatch(actions.comment(""));



        try {
            const start_time = Date.now()
            // eslint-disable-next-line
            var response = await API.post("user_story_chat.php", {
                action: "send",
                corp_code: getUser.user.corp,
                groupId: props.data.id,
                message: message,
                messagedBy: getUser.user.empId || props.data.messagedBy,
                msgId: msgId ? msgId : " ",
                groupName: `${getSubStringId(state.groupList.project_name, 3)}-${props.data.id}-${state.groupList.story_title}`,
                groupEmail: uniqueEmails,
                projectId: getUser.user.projectId,
                reply_id: commentDetails.id ? commentDetails.id : "",
                sub_group_ids: [...new Set(groupTask)]
            }, {}, false);
            const end_time = Date.now()
            getMessages(dispatch, getUser.user, props.data);
            setEmployees([])
            setDisable(false)
            activities && logEntry({
                user_id: getUser.user.userName, logging_level: 3,
                activity_id: activities["Chat"], sub_activity: "Task Chat - Join Meeting",
                response_time: (end_time - start_time), task_meta_data: { task_id: props.data.id }
            },getUser)
        } catch (error) {
            setErrorMessage("Failed to send the message")
            activities && logEntry({
                user_id: getUser.user.userName, logging_level: 2,
                activity_id: activities["Chat"], sub_activity: "Task Chat - Join Meeting",
                error_message: error.message, task_meta_data: { task_id: props.data.id }
            },getUser)
        }
    }

    useEffect(() => {

        //checking it is a link
        //renderMessageContent(state.comment);
        if (state.comment.trim() !== "") {
            setErrorMessage(null);
            //console.log('UseEffect State comment',state.comment);
        }
    }, [state.comment])

    //handling the  links in the messages
    // const renderMessageContent = (state.comment) => {
    //     const urlRegex = /(https?:\/\/[^\s]+)/g;
    //     const messageParts = state.comment.split(urlRegex);

    //     return messageParts.map((part, index) => {
    //       if (part.match(urlRegex)) {
    //         console.log('part:',part);
    //         return (
    //           <a key={index} href={part} target="_blank" rel="noopener noreferrer">
    //             {part}
    //           </a>
    //         );
    //       } else {
    //         return <span key={index}>{part}</span>;
    //       }
    //     });
    //   };

    const sendMessage = async (message = null) => {
        let otherEmails = [];
        let commentInfo = commentDetails
        setCommentDetails({})
        //console.log('state.message:',state.comment);

        otherEmails = state.groupList.data
            ?.filter((item) => {
                return (
                    item.full_role !== 'Contributor' &&
                    item.full_role !== 'Limited Access Contributor' &&
                    item.full_role !== 'Admin'
                );
            })
            .map((item) => {
                return item.email;
            });

        let taskEmails = [];
        if (state.groupList.data && state.groupList.data.length > 0) {
            const firstDataItem = state.groupList.data[0];
            taskEmails.push(firstDataItem.assigned_to_email || '');
            taskEmails.push(firstDataItem.assigned_by_email || '');
        }

        // Combine the two arrays and remove duplicates
        //console.log(message)
        let allEmails = [...taskEmails, ...otherEmails];
        let uniqueEmails = [...new Set(allEmails)];

        if (state.comment.trim() !== "" || message !== null) {
            setErrorMessage(null)
            setDisable(true)
            // dispatch(isLoading());
            state.taskComments.push({
                "groupId": props.data.id,
                "message": state.comment.trim() !== "" ? state.comment : message,
                "messagedBy": getUser.user.empId || props.data.messagedBy,
                "messagedTime": "",
                "reply_message": null,
                "reply_path": null,
                "reply_username": null,
                "username": getUser.user.fullName,
                sub_group_ids: [...new Set(groupTask)],
                "isLoading": true
            });

            let comment = message ? message : state.comment;
            function isLink(str) {
                // Regular expression to match URLs
                const urlRegex = /(https?:\/\/[^\s]+)/;
                return urlRegex.test(str);
            }

            // Example usage:
            const text = comment;
            let test = comment;
            // Check if the comment contains any new links
            if (isLink(text)) {
                // Find all existing hyperlinks in the comment and wrap them with anchor tags
                test = test.replace(/(<a href="([^"]+)">([^<]+)<\/a>)/g, '$2');

                // Replace any new links with anchor tags
                test = test.replace(/(https?:\/\/[^\s]+)/g, "<a href='$1' target='_blank'>$1</a>");
            }
            setHandleHover(false);
            dispatch(actions.comment(""));
            try {
                const start_time = Date.now()
                // eslint-disable-next-line
                var response = await API.post("user_story_chat.php", {
                    action: "send",
                    corp_code: project_name,
                    groupId: props.data.id,
                    message: test,
                    //" <a href='https://www.flipkart.com/' target='_blank'>Test Link</a>"
                    messagedBy: getUser.user.empId || props.data.messagedBy,
                    msgId: msgId ? msgId : " ",
                    groupName: `${getSubStringId(state.groupList.project_name, 3)}-${props.data.id}-${state.groupList.story_title}`,
                    groupEmail: uniqueEmails,
                    projectId: projectId,
                    reply_id: commentInfo.id ? commentInfo.id : "",
                    sub_group_ids: [...new Set(groupTask)]
                }, {}, false);
                const end_time = Date.now()
                getMessages(dispatch, getUser.user, props.data);
                setDisable(false);
                setHandleHover(false);
                setCommentDetails({});
                setEmployees([])
                dispatch(isLoaded());
                test = '';
                activities && logEntry({
                    user_id: getUser.user.userName, logging_level: 3,
                    activity_id: activities["Chat"], sub_activity: "Task Chat - Send Message",
                    response_time: (end_time - start_time), task_meta_data: { task_id: props.data.id }
                },getUser)

            } catch (error) {
                //  console.log("error", error)
                setDisable(false)
                setErrorMessage("Failed to send the message")
                activities && logEntry({
                    user_id: getUser.user.userName, logging_level: 2,
                    activity_id: activities["Chat"], sub_activity: "Task Chat - Send Message",
                    error_message: error.message, task_meta_data: { task_id: props.data.id }
                },getUser)
            }
        }


        else {
            setDisable(false)
            setHideButton(false)
            setErrorMessage("Please type the message");
        }
    }

    // on enter message will be send
    // const handleKeypress = e => {
    //     //it triggers by pressing the enter key
    //     if (e.which === 13) {
    //         if (state.comment.trim() !== "") {
    //             //   console.log("in if")
    //             sendMessage();
    //         } else {
    //             //   console.log("in else")
    //             fileHandle(docFile)
    //         }
    //     }
    // };



    // for sending files or images
    // eslint-disable-next-line
    const fileHandle = async (file) => {
        let commentInfo = commentDetails
        setCommentDetails({});
        let otherEmails = state.groupList.data
            ?.filter((item) => {
                return (
                    item.full_role !== 'Contributor' &&
                    item.full_role !== 'Limited Access Contributor' &&
                    item.full_role !== 'Admin'
                );
            })
            .map((item) => {
                return item.email;
            });

        let taskEmails = [];
        if (state.groupList.data && state.groupList.data.length > 0) {
            const firstDataItem = state.groupList.data[0];
            taskEmails.push(firstDataItem.assigned_to_email || '');
            taskEmails.push(firstDataItem.assigned_by_email || '');
        }

        // Combine the two arrays and remove duplicates
        let allEmails = [...taskEmails, ...otherEmails];
        let uniqueEmails = [...new Set(allEmails)];

        // state.taskComments.push({
        //     "groupId": props.data.id,
        //     "message": state.comment,
        //     "messagedBy": getUser.user.empId,
        //     "messagedTime": "",
        //     "path": URL.createObjectURL(docFile) || URL.createObjectURL(copyfile),
        //     "reply_message": null,
        //     "reply_path": null,
        //     "reply_username": null,
        //     "username": getUser.user.fullName
        // });

        // let comment = state.comment;
        // dispatch(actions.comment(""));

        if (file !== "" && file.name !== undefined) {
            setDisable(true)
            dispatch(isLoading());
            const data = new FormData();
            data.append('file', file);
            data.append('message', file.name);
            // required data for send message
            data.append('action', 'media');
            data.append('corp_code', project_name);
            data.append('groupId', props.data.id);
            data.append('messagedBy', getUser.user.empId || props.data.messagedBy);
            data.append('api', CHATAPI);
            data.append('groupName', `${getSubStringId(state.groupList.project_name, 3)}-${props.data.id}-${state.groupList.story_title}\n\n${"Attached New File"}`);
            data.append('groupEmail', uniqueEmails);
            data.append('reply_id', commentInfo.id ? commentInfo.id : "");
            [...new Set(groupTask)].forEach((task, index) => {
                data.append(`sub_group_ids[${index}]`, task);
            });
            try {
                const start_time = Date.now()
                await API.post("user_story_chat1.php", data
                    , {}, false);
                const end_time = Date.now()
                getMessages(dispatch, getUser.user, props.data);
                dispatch(actions.comment(""));
                setChat(0)
                setDocFile({})
                setDisable(false)
                setHandleHover(false);
                setCommentDetails({});
                setHideButton(false)
                setEmployees([])
                activities && logEntry({
                    user_id: getUser.user.userName, logging_level: 3,
                    activity_id: activities["Chat"], sub_activity: "Task Chat - Send File",
                    response_time: (end_time - start_time), task_meta_data: { task_id: props.data.id }
                },getUser)
            } catch (error) {
                console.log(error)
                setDisable(false)
                setHideButton(false)
                activities && logEntry({
                    user_id: getUser.user.userName, logging_level: 2,
                    activity_id: activities["Chat"], sub_activity: "Task Chat - Send File",
                    error_message: error.message, task_meta_data: { task_id: props.data.id }
                },getUser)
            }
            setDisable(false)
            dispatch(isLoaded());
        } else {
            setDisable(false)
            handleChatClose();
            sendMessage();
        }
    }

    //checking it is link
    // function isLink(input) {
    //     // Regular expression to match URLs
    //     const urlRegex = /(https?:\/\/[^\s]+)/;

    //     // Test if the input matches the URL regex
    //     return urlRegex.test(input);
    // }


    // console.log(state.comment)
    // for getting pasted image's value
    const myPaste = (e) => {
        //working
        //  console.log('my paste comments:',state.comment);


        window.addEventListener('paste', e => {
            setCopyFile(e.clipboardData.files[0])
            if (e.clipboardData.files.length !== 0) {
                setChat(2)
            }
        });

    }
    // const handlePaste = (event) => {
    //     // Get the pasted content
    //     const pastedText = (event.clipboardData || window.clipboardData).getData('text');

    //     // Check if the pasted content is a link or plain text
    //     if (isLink(pastedText)) {
    //         // If it's a link, handle it accordingly
    //         onPaste(pastedText, true); // Pass true to indicate it's a link
    //     } else {
    //         // If it's plain text, handle it accordingly
    //         onPaste(pastedText, false); // Pass false to indicate it's plain text
    //     }};

    const handleDoc = (file) => {
        const fileData = file.file
        // console.log("file",fileData)
        setDocFile(fileData)
    }

    var textInput = useRef(null);
    // for handling reply 
    const handlecom = (comment) => {
        setInfoOpen(false)
        setCommentDetails(comment);
        setHandleHover(true);
        if (textInput) textInput.current.focus();
    }

    const handleMouseOut = () => {
        setHandleHover(false);
        setCommentDetails({})
    };

    const [size, setSize] = useState({ width: isMobile ? '90%' : 700, height: 500 });

    const handleResizeStop = (e, direction, ref, d) => {
        setSize((prevSize) => ({
            width: prevSize.width + d.width,
            height: prevSize.height + d.height,
        }));
    };

    const handleDrag = (e, data) => {
        // Handle drag event if needed
        // console.log('Dragging...', data.x, data.y);
    };

    const getInitialPosition = () => {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight
        const componentWidth = isMobile ? viewportWidth : 438;
        const componentHeight = isMobile ? viewportHeight - 510 : 77.5;

        const initialX = componentWidth;
        const initialY = componentHeight;
        return { x: initialX, y: initialY };
    };

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.which === 13) {
            e.preventDefault();
            if (state.comment.trim()===''){
                setErrorMessage("Please type the message");
            }
            else{
                if (state.comment.trim() !== "") {
                    handleChatClose();
                    sendMessage();
    
                } else {
                    fileHandle(docFile)
                }           
            }
        }
    };

    const [hideButtons, setHideButton] = useState(false)

    const handleToggleNames = () => {
        setShowAllNames(!showAllNames);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        const position = e.target.selectionStart;
        dispatch(actions.comment(value));

        // Find the last occurrence of '@' before the cursor position
        const atIndex = value.lastIndexOf('@', position - 1);
        if (atIndex !== -1) {
            const textAfterAt = value.substring(atIndex, position);
            const shouldShowList = textAfterAt;
            if (shouldShowList === '@') {
                setShowList(shouldShowList);
            } else {
                setShowList(false);
            }
        } else {
            setShowList(false);
        }
    };

    const handleItemClick = (item) => {

        let inputValue = state.comment
        const atIndex = inputValue.lastIndexOf('@');

        // Replace text after '@' with the selected item
        const newValue =
            inputValue.substring(0, atIndex + 1) +
            item.full_name +
            ' ';

        dispatch(actions.comment(newValue));
        setShowList(false);

        // Ensure the cursor is placed correctly after the update

        setTimeout(() => {
            const newPosition = newValue.length;
            textInput.current.setSelectionRange(newPosition, newPosition);
            textInput.current.focus();
        }, 0);
    };

    const handleDelete = async (comments) => {
        setInfoOpen(false)
        try {
            const start_time = Date.now()
            var response = await API.post("user_story_chat.php", {
                action: "messageDelete",
                messageId: comments.id,
                sub_group_ids: groupTask,
                deleteMessage: comments.message,
                deleteMessageTime: comments.messagedTime
            }, {}, false);
            const end_time = Date.now()
            if (response.status === "True") {
                getMessages(dispatch, getUser.user, props.data);
                activities && logEntry({
                    user_id: getUser.user.userName, logging_level: 3,
                    activity_id: activities["Chat"], sub_activity: "Task Chat - Delete Message",
                    response_time: (end_time - start_time), task_meta_data: { task_id: props.data.id }
                },getUser)

            }
        } catch (error) {
            console.log(error)
            activities && logEntry({
                user_id: getUser.user.userName, logging_level: 2,
                activity_id: activities["Chat"], sub_activity: "Task Chat - Delete Message",
                error_message: error.message, task_meta_data: { task_id: props.data.id }
            },getUser)

        }
    }

    const addEmployee = (newEmployee) => {
        setEmployees((prevEmployees) => {
            // Check if the employee with the same emp_id already exists
            const exists = prevEmployees.some(
                (employee) => employee.emp_id === newEmployee.emp_id
            );

            // If not exists, push the new employee to the array
            if (!exists) {
                return [...prevEmployees, newEmployee];
            }

            // Otherwise, return the original array without modification
            return prevEmployees;
        });
    };


    useEffect(() => {
        // eslint-disable-next-line
        if (employees.length > 0 && props.data.group_task_type === 'Limited' || props.data.group_task_type === 'Full') {
            setGroupTask(groupTaskList?.filter(employee =>
                employees?.some(task => task.emp_id === employee.assigned_to)
            ).map(item => { return item.us_id }))
        }
        // eslint-disable-next-line
    }, [employees])

    const handleGetInfo = async (comments) => {
        setInfoOpen(false)
        setInfoMessageId(null)
        try {
            var response = await API.post("group_chat.php", {
                action: "getUserInfo",
                ready_by: comments.read_by
            }, {}, false);
            if (response.status === "True") {
                setInfoUsers(response.data.filter(item => {
                    return item.emp_id !== getUser.user.empId
                }))
                setInfoOpen(true)
                setInfoMessageId(comments.id)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleInfoClose = () => {
        setInfoOpen(false)
    }

    return (
        <div>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                // className={classNames.modal}
                open={props.open}
                onClose={props.handleClose}
                closeAfterTransition
                disableBackdropClick={true}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >

                <Fade in={props.open}>
                    <Draggable handle="#draggable-modal" onDrag={handleDrag} defaultPosition={getInitialPosition()}>
                        <Resizable
                            size={size}
                            onResizeStop={handleResizeStop}
                            minWidth={isMobile ? "90%" : 700}
                            minHeight={500}
                        >
                            <div
                                className={classNames.paper}

                            >
                                <div className="user-modal-dialog">

                                    <div className="modal-content p-2 tsk" style={{ borderRadius: '10px', height: size.height, overflow: 'hidden' }}>
                                        {

                                            <>
                                                <div id={`${isMobile ? "" : "draggable-modal"}`} class="modal-header" style={{ backgroundColor: '#eaeaea', cursor: 'move', position: 'relative' }}>
                                                    <div className="column" style={{ width: '100%' }}>
                                                        <h6 id={`${isMobile ? "draggable-modal" : ""}`} className="modal-title mb-2">
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <span>
                                                                    {MAINTASK}: {getSubStringId(props.data.project_name || state.groupList.project_name, 3)}-{" "}{props.data.id}{" "}{state.groupList.story_title}
                                                                </span>
                                                                <button
                                                                    style={{ backgroundColor: 'transparent', border: '0' }}
                                                                    type="button"
                                                                    onClick={props.handleModalClose}
                                                                    onTouchEnd={props.handleModalClose}
                                                                    className="d-flex align-items-right"
                                                                    data-dismiss="modal"
                                                                >
                                                                    <i className="mdi mdi-close text-black"></i>
                                                                </button>
                                                            </div>
                                                        </h6>
                                                        {/* <p class="modal-title" title={state.groupList}>{state.groupList}</p> */}
                                                        <div>
                                                            {/* <label className='badge badge-pill badge-light text-color-green' title={`${state.groupList.assigned_to}-Assigned To`}>{state.groupList.assigned_to}-AT</label>{" "}
                                                            <label className='badge badge-pill badge-light text-color-green' title={`${state.groupList.assigned_by}-Assigned By`}>{state.groupList.assigned_by}-AB</label>{" "}
                                                           */}


                                                            <div className="d-inline-flex align-items-center gap-2">
                                                                <label className="badge badge-pill badge-light text-color-green mt-1" title={`${state.groupList.assigned_to}-Assigned To`}>
                                                                    {state.groupList.assigned_to}-AT
                                                                </label>{" "}
                                                                <label className="badge badge-pill badge-light text-color-green mt-1" title={`${state.groupList.assigned_by}-Assigned By`}>
                                                                    {state.groupList.assigned_by}-AB
                                                                </label>{" "}
                                                                {state.groupList && String(state.groupList.assigned_to_id) === String(getUser.user.empId) && (
                                                                    <button 
                                                                        className="btn btn-sm" 
                                                                        style={{ backgroundColor: '#7290ce', cursor: 'pointer', color: 'white', marginLeft: 5, marginTop: 5, marginBottom: 5, width: '80px', textAlign: 'center', height: 'fit-content' }} 
                                                                        title="Delegate this task" 
                                                                        onClick={() => {
                                                                            if (props.data.active_status === '-1') {
                                                                                Alert('warning', `This ${MAINTASK} is blocked you can not delegate it`);
                                                                            } else {
                                                                                handleDelegateOpen();
                                                                            }
                                                                        }}
                                                                    >
                                                                        Delegate
                                                                    </button>
                                                                )}
                                                            </div>
                                                            <div class="" style={{ position: "relative", float: 'right', display: 'flex', justifyContent: 'flex-end' }}>
                                                                {/* marginBottom:'2.5rem' ,marginRight:'1rem' */}
                                                                {/* <SearchIcon fontSize={"medium"} backgroundColor={"green"}/> */}
                                                                <input type="text"
                                                                    className="form-control form-control-sm"
                                                                    style={{ paddingRight: '30px', }}
                                                                    placeholder=" Search here" aria-label="Recipient's username" aria-describedby="button-addon2"
                                                                    value={searchTerm}
                                                                    onChange={handleSearchChange}
                                                                    onKeyPress={handleKeyPress}
                                                                    onDoubleClick={(e) => e.stopPropagation()}
                                                                    onMouseDown={(e) => e.stopPropagation()}
                                                                    onMouseUp={(e) => e.stopPropagation()}

                                                                />
                                                                {searchTerm && (
                                                                    <button
                                                                        onClick={clearSearch}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            right: '10px',
                                                                            top: '40%',
                                                                            transform: 'translateY(-50%)',
                                                                            backgroundColor: 'transparent',
                                                                            border: 'none',
                                                                            cursor: 'pointer',
                                                                            padding: '0',
                                                                            outline: 'none',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    >
                                                                        &#x2715; {/* This is the 'X' character */}
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {
                                                                role_array[getUser.user.role] !== LIMITED_ACCESS_CONTRIBUTOR && props.data.outsideApp !== true && (props.data.main_task_id === "0" || props.data.main_task_id === null) ?
                                                                    <>
                                                                        <button style={{ border: 'none', background: 'transparent' }} onClick={handleToggleNames} className='dropdown-toggle'></button>
                                                                        <br />
                                                                        {showAllNames && (
                                                                            <div className={`user-modal-dialog overflow-scroll`} style={{ overflowY: "scroll", ...(isMobile ? { maxHeight: '200px' } : { maxHeight: "290px" }), ...(isMobile ? { minHeight: '70px' } : { minHeight: "100px" }) }}>
                                                                                {state.groupList.data?.filter(item => item.full_role !== 'Admin').map(item => (
                                                                                    <>
                                                                                        <label className='badge badge-pill badge-light text-color-green mr-1 mtc' title={`${item.display_name !== null ? item.display_name : item.full_name}-${role_array[item.full_role]}`}>
                                                                                            {`${item.display_name !== null ? item.display_name : item.full_name}-${role_array[item.full_role]}`}
                                                                                        </label>

                                                                                    </>
                                                                                ))
                                                                                }
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>

                                                    </div>
                                                    {/* <button style={{ backgroundColor: 'transparent', border: '0' }} type="button" onClick={props.handleModalClose} onTouchEnd={props.handleModalClose} className="d-flex align-items-right" data-dismiss="modal"><i class="mdi mdi-close text-black"></i></button> */}
                                                </div>
                                                <div className="modal-body overflow-md-scroll overflow-auto" ref={modalBodyRef}>
                                                    <div className="" style={{ display: 'flex', flexDirection: 'column-reverse' }}>

                                                        {chatActive && showResults && filteredChatData.length > 0
                                                            ? filteredChatData.map((item, index) => (
                                                                <>
                                                                    <Element
                                                                        name={`message-${item.id}`}
                                                                        key={item.id}
                                                                        onClick={() => handleClick(item.id)}
                                                                        style={{

                                                                            marginBottom: "5px",
                                                                            backgroundColor:
                                                                                highlightedMessageId === item.id ? "#e1e1e1" : "#fff",
                                                                            border:
                                                                                highlightedMessageId === item.id,


                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <q style={{ color: 'grey', fontSize: "8px" }}>{convertPSTtoLocalTime(item.messagedTime)}</q>

                                                                        <div className='flex ' style={{ display: 'flex' }}>
                                                                            <div style={{ fontWeight: "bold", color: 'green' }}>
                                                                                {item.username} :
                                                                            </div>
                                                                            <Highlighter
                                                                                highlightClassName="YourHighlightClass"
                                                                                searchWords={[searchTerm]}
                                                                                autoEscape={true}
                                                                                //   style={{color:"yellow"}}
                                                                                textToHighlight={item.message}
                                                                            />
                                                                        </div>
                                                                        {/* </div> */}

                                                                    </Element>
                                                                    {index < filteredChatData.length - 1 && <hr />}
                                                                </>


                                                            ))
                                                            : showResults && <div>No results found</div>}


                                                        {!showResults && state.taskComments !== '' ? state.taskComments.slice(0).reverse().map((comments, index) => {

                                                            return (
                                                                <div key={index}>
                                                                    {
                                                                        comments.messagedBy !== (getUser.user.empId || props.data.messagedBy) ?
                                                                            <p className="text-left pr-3"  >
                                                                                <p className="pt-2" style={{ color: 'green' }}>{comments.username}&nbsp;<q style={{ color: 'grey', fontSize: "8px" }}>{convertPSTtoLocalTime(comments.messagedTime)}</q></p>
                                                                                {comments.path ?
                                                                                    <div style={{ height: "67%", backgroundColor: "#f3f3f3", float: "left", borderRadius: '7px' }}>

                                                                                        {/* for image with reply content and dropdown left side content */}
                                                                                        {comments.reply_message !== null ?
                                                                                            <li className="dropdown show" style={{ listStyle: "none", float: "right" }}>
                                                                                                {
                                                                                                    comments.is_deleted === "true" ?
                                                                                                    null
                                                                                                    :
                                                                                                <div style={{ backgroundColor: "#D2ECDF", borderRadius: "7px", padding: "10px" }}>
                                                                                                    <p style={{ color: "green", }}>{comments.reply_username}</p>
                                                                                                    <p style={{ display: "inline-block", textAlign: 'left', width: "100%", whiteSpace: "normal", overflow: "hidden !important", textOverflow: "ellipsis", paddingRight: "5px" }}>
                                                                                                        {comments.reply_path ?
                                                                                                            comments.reply_path.substr(comments.reply_path.length - 4) === "blob" && comments.reply_message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                // eslint-disable-next-line 
                                                                                                                <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                    <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" /></a> :
                                                                                                                !comments.reply_path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                    //  eslint-disable-next-line  
                                                                                                                    <a download={comments.reply_message} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        {comments.reply_message}</a> :
                                                                                                                    //  eslint-disable-next-line  
                                                                                                                    <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" /></a>
                                                                                                            :
                                                                                                            <div style={{ whiteSpace: 'break-spaces' }} dangerouslySetInnerHTML={{ __html: comments.reply_message }}></div>
                                                                                                        }
                                                                                                    </p>
                                                                                                    </div>
                                                                                        }
                                                                                            {
                                                                                                comments.is_deleted === "true" ?
                                                                                                    null
                                                                                                    :
                                                                                                    <a href="/" style={{ borderRadius: '30px', color: "gray", padding: '10px', float: 'right', marginTop: '-8px', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                                    </a>
                                                                                            }
                                                                                                {/* drop-down icon and reply button */}
                                                                                                <div className="dropdown-menu dropdown-menu-left navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                    {/* eslint-disable-next-line   */}
                                                                                                    <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                                </div>
                                                                                                {/* End of drop-down icon and reply button */}

                                                                                                <p style={{ backgroundColor: "#f3f3f3", width: '100%', textAlign: 'right', padding: "12px 10px 12px 14px", borderRadius: "7px" }}>
                                                                                                    {/* {comments.message} */}
                                                                                                    {comments.is_deleted === "true" ? <div style={{ whiteSpace: 'break-spaces', color : 'grey'}} dangerouslySetInnerHTML={{ __html:`${comments.username} deleted this message`}}></div>
                                                                                                    :
                                                                                                    comments.path.substr(comments.path.length - 4) === "blob" && comments.message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                        //  eslint-disable-next-line
                                                                                                        <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                            <img style={{ marginTop: '-12px', marginRight: '12px' }} alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                        :
                                                                                                        !comments.path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                            //  eslint-disable-next-line
                                                                                                            <a download={comments.message} className='text-primary' target="_blank" href={comments.path}>{comments.message}</a>
                                                                                                            :
                                                                                                            //  eslint-disable-next-line 
                                                                                                            <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                                <img style={{ marginTop: '-14px', marginRight: '14px' }} alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                    }
                                                                                                    {/* eslint-disable-next-line  */}

                                                                                                </p>
                                                                                            </li>

                                                                                            :
                                                                                            // for image with left side dropdown and image only
                                                                                            <li className="dropdown show" style={{ listStyle: "none" }}>
                                                                                                {
                                                                                                    comments.is_deleted === "true" ?
                                                                                                        null
                                                                                                        :
                                                                                                        <a href="/" style={{ borderRadius: '30px', color: "gray", padding: '0px', float: 'right', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                                        </a>
                                                                                                }
                                                                                                <div className="dropdown-menu dropdown-menu-right navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                    {/* eslint-disable-next-line */}
                                                                                                    <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                                </div>
                                                                                                <p style={{ backgroundColor: "#f3f3f3", padding: "12px 10px 12px 14px", borderRadius: "7px", marginTop: '4px', color: comments.is_deleted === "true" ? 'grey' : 'black' }}>
                                                                                                    {
                                                                                                        comments.is_deleted === "true" ?
                                                                                                            `${comments.username} deleted this message`
                                                                                                            :
                                                                                                            comments.path.substr(comments.path.length - 4) === "blob" && comments.message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                //   eslint-disable-next-line 
                                                                                                                <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                                    <img style={{ marginTop: '-8px', marginRight: '12px' }} alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                                :
                                                                                                                !comments.path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                    //    eslint-disable-next-line 
                                                                                                                    <a download={comments.message} className='text-primary' target="_blank" href={comments.path}>{comments.message}</a>
                                                                                                                    :
                                                                                                                    //  eslint-disable-next-line 
                                                                                                                    <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                                        <img style={{ marginTop: '-8px', marginRight: '12px' }} alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                    }
                                                                                                    {/* eslint-disable-next-line */}

                                                                                                </p>
                                                                                            </li>
                                                                                        }</div>
                                                                                    :
                                                                                    //for message display reply content and dropdown left side reply messages 
                                                                                    comments.reply_message !== null ?
                                                                                        <li className="dropdown show" style={{ listStyle: "none", float: "left" }}>
                                                                                            {
                                                                                                comments.is_deleted === "true" ?
                                                                                                    null
                                                                                                    :
                                                                                                    <div style={{ backgroundColor: "#D2ECDF", borderRadius: "7px", width: '100%', textAlign: 'left', padding: "12px 10px 12px 14px" }}>
                                                                                                        <p style={{ color: "green", }}>{comments.reply_username}</p>
                                                                                                        <p style={{ display: "inline-block", whiteSpace: "normal", overflow: "hidden !important", textOverflow: "ellipsis", paddingRight: "12px" }}>
                                                                                                            {comments.reply_path ?
                                                                                                                comments.reply_path.substr(comments.reply_path.length - 4) === "blob" && comments.reply_message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                    // eslint-disable-next-line 
                                                                                                                    <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" /></a> :
                                                                                                                    !comments.reply_path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                        //  eslint-disable-next-line  
                                                                                                                        <a download={comments.reply_message} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                            {comments.reply_message}</a> :
                                                                                                                        //  eslint-disable-next-line  
                                                                                                                        <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                            <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" /></a>
                                                                                                                :
                                                                                                                <div style={{ whiteSpace: 'break-spaces' }} dangerouslySetInnerHTML={{ __html: comments.reply_message }}></div>
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                            }
                                                                                            {
                                                                                                comments.is_deleted === "true" ?
                                                                                                    null
                                                                                                    :
                                                                                                    <a href="/" style={{ borderRadius: '30px', color: "gray", padding: '10px', float: 'right', marginTop: '-8px', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                                    </a>
                                                                                            }
                                                                                            <div className="dropdown-menu dropdown-menu-left navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                {/* eslint-disable-next-line   */}
                                                                                                <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                            </div>
                                                                                            <p style={{ backgroundColor: "#f3f3f3", width: '100%', textAlign: 'left', padding: "12px 10px 12px 14px", borderRadius: "7px", marginTop: '-8px' }}>
                                                                                                <div style={{ whiteSpace: 'break-spaces', color: comments.is_deleted === "true" ? 'grey' : 'black' }} dangerouslySetInnerHTML={{ __html: comments.is_deleted === 'true' ? `${comments.username} deleted this message` : comments.message }}></div>
                                                                                                {/* eslint-disable-next-line  */}
                                                                                            </p>
                                                                                        </li>
                                                                                        :
                                                                                        // for message display dropdown left side of chat box messages
                                                                                        <li className="dropdown show" style={{ listStyle: "none" }}>
                                                                                            <div className="" style={{
                                                                                                margin: '0px', display: 'flex',
                                                                                                alignItems: 'normal',
                                                                                                justifyContent: 'start'
                                                                                            }}>
                                                                                                <div className="" style={{ maxWidth: 'fit-content', padding: '0px' }}>
                                                                                                    <p style={{ backgroundColor: "#f3f3f3", width: 'fit-content', textAlign: 'left', padding: "12px 10px 12px 14px", borderRadius: "7px 0px 0px 7px", paddingTop: '12px', paddingLeft: '14px' }}>
                                                                                                        <div style={{ whiteSpace: 'break-spaces', color: comments.is_deleted === "true" ? 'grey' : 'black' }} dangerouslySetInnerHTML={{ __html: comments.is_deleted === 'true' ? `${comments.username} deleted this message` : comments.message }}></div>
                                                                                                    </p>
                                                                                                </div>
                                                                                                <div className="" style={{ backgroundColor: "#f3f3f3", marginBottom: '4.5px', padding: '0px', borderRadius: "0px 7px 7px 0px" }}>
                                                                                                    {
                                                                                                        comments.is_deleted === "true" ?
                                                                                                            null
                                                                                                            :
                                                                                                            <a href="/" style={{ borderRadius: '30px', color: "gray", padding: '0px', marginTop: '12px', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                                            </a>
                                                                                                    }
                                                                                                    <div className="dropdown-menu dropdown-menu-right navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                        {/* eslint-disable-next-line   */}
                                                                                                        <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            {/* <p style={{backgroundColor:"#f3f3f3", width:'fit-content',textAlign: 'left', padding: "12px 10px 12px 14px", borderRadius:"7px" , paddingTop:'12px',paddingLeft:'14px',wordBreak:'break-all'}}>
{comments.message} </p> */}
                                                                                            {/* eslint-disable-next-line  */}


                                                                                        </li>}</p> :
                                                                            //user messages     user message    user  messages
                                                                            <p className="text-right pr-3" style={{ minWidth: "fit-content" }} ><p className="pt-2" style={{ color: 'green', minWidth: "fit-content" }}>{comments.username}&nbsp;<q style={{ color: 'grey', fontSize: "8px" }}>{convertPSTtoLocalTime(comments.messagedTime)}</q></p>
                                                                                {comments.path ?
                                                                                    <div style={{ height: "67%", backgroundColor: "#f3f3f3", padding: '0px', float: "right" }}>

                                                                                        {/* for image with reply content and dropdown for right side chat    */}
                                                                                        {comments.reply_message !== null ?
                                                                                            <li className="dropdown show" style={{ listStyle: "none", float: "right" }}>
                                                                                                {
                                                                                                    comments.is_deleted === 'true' ?
                                                                                                    null
                                                                                                    :
                                                                                                    <div style={{ backgroundColor: "#D2ECDF", borderRadius: "7px", padding: "10px" }}>
                                                                                                    <p style={{ color: "green", }}>{comments.reply_username}</p>
                                                                                                    <p style={{ display: "inline-block", textAlign: 'right', width: "100%", whiteSpace: "normal", overflow: "hidden !important", textOverflow: "ellipsis", paddingRight: "5px" }}>
                                                                                                        {comments.reply_path ?
                                                                                                            comments.reply_path.substr(comments.reply_path.length - 4) === "blob" && comments.reply_message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                // eslint-disable-next-line 
                                                                                                                <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                    <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" /></a> :
                                                                                                                !comments.reply_path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                                    //  eslint-disable-next-line  
                                                                                                                    <a download={comments.reply_message} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        {comments.reply_message}</a> :
                                                                                                                    //  eslint-disable-next-line  
                                                                                                                    <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" /></a>
                                                                                                            :
                                                                                                            <div style={{ whiteSpace: 'break-spaces' }} dangerouslySetInnerHTML={{ __html: comments.reply_message }}></div>

                                                                                                        }
                                                                                                    </p></div>
                                                                                                    }
                                                                                                     {
                                                                                                comments.is_deleted === "true" ?
                                                                                                    null
                                                                                                    :
                                                                                                    <a href="/" style={{ borderRadius: '30px', color: "gray", padding: '10px', float: 'right', marginTop: '-8px', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                                    </a>
                                                                                            }
                                                                                                <div className="dropdown-menu dropdown-menu-left navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                    {/* eslint-disable-next-line   */}
                                                                                                    <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                                     {/* eslint-disable-next-line */}
                                                                                                    <a className="dropdown-item" onClick={() => handleDelete(comments)}>Delete</a>
                                                                                                </div>
                                                                                                <p style={{ backgroundColor: "#f3f3f3", width: '100%', textAlign: 'right', padding: "12px 10px 12px 14px", borderRadius: "7px" }}>
                                                                                                    {/* {comments.message} */}
                                                                                                    {comments.is_deleted === "true" ? <div style={{ whiteSpace: 'break-spaces', color:  'grey'}} dangerouslySetInnerHTML={{ __html:"you deleted this message"}}></div>
                                                                                                    : 
                                                                                                    comments.path.substr(comments.path.length - 4) === "blob" && comments.message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                        //  eslint-disable-next-line
                                                                                                        <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                            <img style={{ marginTop: '-20px', marginRight: '15px' }} alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                        :
                                                                                                        !comments.path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                            //  eslint-disable-next-line
                                                                                                            <a download={comments.message} className='text-primary' target="_blank" href={comments.path}>{comments.message}</a>
                                                                                                            :
                                                                                                            //  eslint-disable-next-line 
                                                                                                            <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                                <img style={{ marginTop: '-20px', marginRight: '15px' }} alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                    }
                                                                                                    {/* eslint-disable-next-line  */}
                                                                                                </p>
                                                                                            </li>
                                                                                            :
                                                                                            // for image with right side dropdown and image only
                                                                                            <li className="dropdown show" style={{ listStyle: "none" }}>
                                                                                                {/* drop-down icon and reply button */}
                                                                                                {
                                                                                                    comments.is_deleted === 'true' ?
                                                                                                        null :
                                                                                                        <p style={{ borderRadius: '30px', color: "gray", padding: '0px', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                                        </p>
                                                                                                }
                                                                                                <div className="dropdown-menu dropdown-menu-right navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                    {/* eslint-disable-next-line */}
                                                                                                    <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                                    {/* eslint-disable-next-line */}
                                                                                                    <a className="dropdown-item" onClick={() => handleGetInfo(comments)}>Info</a>
                                                                                                    {/* eslint-disable-next-line */}
                                                                                                    <a className="dropdown-item" onClick={() => handleDelete(comments)}>Delete</a>

                                                                                                </div>
                                                                                                {
                                                                                                    infoOpen === true && infoMessageId === comments.id ?
                                                                                                        <div className="dropdown show" style={{
                                                                                                            borderRadius: "7px", minWidth: "fit-content", margin: '10px',
                                                                                                            border: '1px solid',
                                                                                                            padding: '5px',
                                                                                                            width: '250px',
                                                                                                            maxHeight: '200px',
                                                                                                            overflow: 'auto',
                                                                                                            float: 'right'

                                                                                                        }}>
                                                                                                            <label style={{
                                                                                                                color: 'green'
                                                                                                            }}><b>Read By</b><label onClick={() => {
                                                                                                                handleInfoClose()
                                                                                                            }} style={{ color: 'red', marginLeft: '10px', cursor: 'pointer' }}><b>X</b></label></label>
                                                                                                            {
                                                                                                                infoUsers?.map((item => {
                                                                                                                    return <div><label>{item.username}</label><br /></div>
                                                                                                                }))
                                                                                                            }
                                                                                                        </div>
                                                                                                        :
                                                                                                        null
                                                                                                }
                                                                                                {/*End of drop-down icon and reply button */}
                                                                                                <p style={{ backgroundColor: "#f3f3f3", width: '100%', textAlign: 'left', padding: "12px 10px 12px 14px", borderRadius: "7px", color: comments.is_deleted === "true" ? 'grey' : 'black' }}>

                                                                                                    {comments.is_deleted === "true" ? "you deleted this message" : comments.path.substr(comments.path.length - 4) === "blob" && comments.message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                        //  eslint-disable-next-line
                                                                                                        <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                            <img style={{ marginTop: '-25px', marginRight: '15px' }} alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                        :
                                                                                                        !comments.path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                                            //  eslint-disable-next-line
                                                                                                            <a download={comments.message} className='text-primary' target="_blank" href={comments.path}>{comments.message}</a>
                                                                                                            :
                                                                                                            //  eslint-disable-next-line 
                                                                                                            <a download={comments.path} className='text-primary' target="_blank" href={comments.path}>
                                                                                                                <img alt={comments.message} src={comments.path} width="400" /></a>
                                                                                                    }
                                                                                                    {/* eslint-disable-next-line */}

                                                                                                </p>
                                                                                            </li>
                                                                                        }</div>
                                                                                    : comments.reply_message !== null ?
                                                                                        <li className="dropdown show" style={{ listStyle: "none", float: "right" }}>
                                                                                        {
                                                                                            comments.is_deleted === "true" ? null : (
                                                                                                <div style={{
                                                                                                    backgroundColor: "#D2ECDF",
                                                                                                    borderRadius: "7px",
                                                                                                    width: '100%',
                                                                                                    textAlign: 'left',
                                                                                                    padding: '12px 10px 12px 14px'
                                                                                                }}>
                                                                                                    <p style={{ color: "green", float: "left" }}>
                                                                                                        {comments.reply_username}
                                                                                                    </p><br />

                                                                                                    <p style={{
                                                                                                        display: "inline-block",
                                                                                                        width: '100%',
                                                                                                        textAlign: 'left',
                                                                                                        whiteSpace: "normal",
                                                                                                        overflow: "hidden !important",
                                                                                                        textOverflow: "ellipsis",
                                                                                                        paddingRight: "5px"
                                                                                                    }}>

                                                                                                        {comments.reply_path ? (
                                                                                                            (() => {
                                                                                                                const matchedMessage = state.taskComments.find(
                                                                                                                    m => m.message === comments.reply_message
                                                                                                                );
                                                                                                                const matchedPath = state.taskComments.find(
                                                                                                                    m => m.path === comments.reply_path
                                                                                                                );

                                                                                                                const shouldHideImage = 
                                                                                                                    (matchedMessage && matchedMessage.is_deleted === "true") || 
                                                                                                                    (matchedPath && matchedPath.is_deleted === "true");

                                                                                                               
                                                                                                                if (shouldHideImage) {
                                                                                                                    return (
                                                                                                                        <img
                                                                                                                            src="https://iconarchive.com/download/i10789/google/noto-emoji-animals-nature/22215-file-folder.ico"
                                                                                                                            alt="Image unavailable"
                                                                                                                            width="30"
                                                                                                                            height="30"
                                                                                                                        />
                                                                                                                    );
                                                                                                                }

                                                                                                                return comments.reply_path.substr(comments.reply_path.length - 4) === "blob" &&
                                                                                                                    comments.reply_message.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                                                                                                                    <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" />
                                                                                                                    </a>
                                                                                                                ) : !comments.reply_path.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                                                                                                                    <a download={comments.reply_message} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        {comments.reply_message}
                                                                                                                    </a>
                                                                                                                ) : (
                                                                                                                    <a download={comments.reply_path} className='text-primary' target="_blank" href={comments.reply_path}>
                                                                                                                        <img alt={comments.reply_message} src={comments.reply_path} width="60" height="60" />
                                                                                                                    </a>
                                                                                                                );
                                                                                                            })()
                                                                                                        ) : (
                                                                                                             <div
                                                                                                                style={{ whiteSpace: 'break-spaces' }}
                                                                                                                dangerouslySetInnerHTML={{ __html: comments.reply_message }}
                                                                                                            />
                                                                                                        )}
                                                                                                    </p>
                                                                                                </div>
                                                                                            )
                                                                                        }


                                                                                            {
                                                                                                comments.is_deleted === "true" ?
                                                                                                    null
                                                                                                    :
                                                                                                    <a href="/" style={{ borderRadius: '30px', color: "gray", padding: '10px', float: 'right', marginTop: '-8px', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                                    </a>
                                                                                            }
                                                                                            <div className="dropdown-menu dropdown-menu-left navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                {/* eslint-disable-next-line   */}
                                                                                                <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                                {/* eslint-disable-next-line */}
                                                                                                <a className="dropdown-item" onClick={() => handleGetInfo(comments)}>Info</a>
                                                                                                {/* eslint-disable-next-line */}
                                                                                                <a className="dropdown-item" onClick={() => handleDelete(comments)}>Delete</a>
                                                                                            </div>
                                                                                            {
                                                                                                infoOpen === true && infoMessageId === comments.id ?
                                                                                                    <div className="dropdown show" style={{
                                                                                                        borderRadius: "7px", minWidth: "fit-content", margin: '10px',
                                                                                                        border: '1px solid',
                                                                                                        padding: '5px',
                                                                                                        width: '250px',
                                                                                                        maxHeight: '200px',
                                                                                                        overflow: 'auto',
                                                                                                        float: 'right'

                                                                                                    }}>
                                                                                                        <label style={{
                                                                                                            color: 'green'
                                                                                                        }}><b>Read By</b><label onClick={() => {
                                                                                                            handleInfoClose()
                                                                                                        }} style={{ color: 'red', marginLeft: '10px', cursor: 'pointer' }}><b>X</b></label></label>
                                                                                                        {
                                                                                                            infoUsers?.map((item => {
                                                                                                                return <div><label>{item.username}</label><br /></div>
                                                                                                            }))
                                                                                                        }
                                                                                                    </div>
                                                                                                    :
                                                                                                    null
                                                                                            }
                                                                                            <p style={{ backgroundColor: "#f3f3f3", width: '100%', padding: "12px 10px 12px 14px", borderRadius: "7px", marginTop: '-8px', textAlign: 'left' }}>
                                                                                                <div style={{ whiteSpace: 'break-spaces', color: comments.is_deleted === "true" ? 'grey' : 'black' }} dangerouslySetInnerHTML={{ __html: comments.is_deleted === 'true' ? "you deleted this message" : comments.message }}></div>
                                                                                                {/* eslint-disable-next-line  */}
                                                                                            </p>
                                                                                        </li>
                                                                                        :
                                                                                        //for message display dropdown right side chat box messages
                                                                                        <li className="dropdown show" style={{ listStyle: "none", width: '100%' }}>
                                                                                            <div className="" style={{
                                                                                                margin: '0px', display: 'flex',
                                                                                                alignItems: 'normal',
                                                                                                justifyContent: 'end'
                                                                                            }}>
                                                                                                <div className="" style={{ padding: '0px' }}>
                                                                                                    <p style={{ backgroundColor: "#f3f3f3", padding: "12px 10px 12px 14px", textAlign: 'left', borderRadius: "7px 0px 0px 7px", float: 'right' }}>
                                                                                                        <div style={{ whiteSpace: 'break-spaces', color: comments.is_deleted === "true" ? 'grey' : 'black' }} dangerouslySetInnerHTML={{ __html: comments.is_deleted === 'true' ? "you deleted this message" : comments.message }}></div>
                                                                                                    </p>
                                                                                                </div>

                                                                                                <div className="" style={{ backgroundColor: "#f3f3f3", marginBottom: '4.5px', padding: '0px', textAlign: 'left', borderRadius: "0px 7px 7px 0px" }}>
                                                                                                    {
                                                                                                        comments.is_deleted === "true" ?
                                                                                                            null
                                                                                                            :
                                                                                                            <>
                                                                                                                {/* eslint-disable-next-line  */}
                                                                                                                < a style={{ borderRadius: '30px', color: "gray", padding: '0px', marginTop: '12px', visibility: comments.isLoading ? 'hidden' : 'visible' }} className="btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
                                                                                                            </>
                                                                                                    }
                                                                                                    <div className="dropdown-menu dropdown-menu-left navbar-dropdown" style={{ borderRadius: "7px", minWidth: "fit-content" }} aria-labelledby="dropdownMenuLink">
                                                                                                        {/* eslint-disable-next-line   */}
                                                                                                        <a className="dropdown-item" onClick={() => handlecom(comments)}>Reply</a>
                                                                                                        {/* eslint-disable-next-line */}
                                                                                                        <a className="dropdown-item" onClick={() => handleGetInfo(comments)}>Info</a>
                                                                                                        {/* eslint-disable-next-line   */}
                                                                                                        <a className="dropdown-item" onClick={() => handleDelete(comments)}>Delete</a>
                                                                                                    </div>
                                                                                                    {
                                                                                                        infoOpen === true && infoMessageId === comments.id ?
                                                                                                            <div className="dropdown show" style={{
                                                                                                                borderRadius: "7px", minWidth: "fit-content", margin: '10px',
                                                                                                                border: '1px solid',
                                                                                                                padding: '5px',
                                                                                                                width: '250px',
                                                                                                                maxHeight: '200px',
                                                                                                                overflow: 'auto',
                                                                                                                float: 'right'

                                                                                                            }}>
                                                                                                                <label style={{
                                                                                                                    color: 'green'
                                                                                                                }}><b>Read By</b><label onClick={() => {
                                                                                                                    handleInfoClose()
                                                                                                                }} style={{ color: 'red', marginLeft: '10px', cursor: 'pointer' }}><b>X</b></label></label>
                                                                                                                {
                                                                                                                    infoUsers?.map((item => {
                                                                                                                        return <div><label>{item.username}</label><br /></div>
                                                                                                                    }))
                                                                                                                }
                                                                                                            </div>
                                                                                                            :
                                                                                                            null
                                                                                                    }
                                                                                                </div>

                                                                                            </div>


                                                                                        </li>}</p>
                                                                    }
                                                                </div>
                                                            )
                                                        }) : null}
                                                    </div>
                                                </div>
                                                {/* {
                                                 state.isLoading &&
                                                 <RootLoader />
                                                 
                                            } */}
                                                <div class="modal-footer m-1 justify-content-center">
                                                    <div className="form-sample col-12">
                                                        <form encType="multipart/form-data" method="post" autoComplete="off">
                                                            {/* <div className="form-sample col-12"> */}
                                                            {/* <label>Resume*</label> */}
                                                            {chat === 1 ?
                                                                <div><button style={{ backgroundColor: 'transparent', border: '0', float: "right" }} type="button" onClick={() => handleChatClose()} className="d-flex align-items-right" ><i class="mdi mdi-close text-black"></i></button>
                                                                    <FilePond
                                                                        allowFileTypeValidation={true}
                                                                        fileValidateTypeLabelExpectedTypes={['allTypes']}
                                                                        allowMultiple={true}
                                                                        // maxFiles={3}
                                                                        maxFiles={1}
                                                                        instantUpload={false}
                                                                        storeAsFile={true}
                                                                        // eslint-disable-next-line
                                                                        credits={"", ""}
                                                                        onaddfilestart={(file) => {
                                                                            handleDoc(file)
                                                                            setHideButton(true)
                                                                        }}
                                                                        // for show uplode icon
                                                                        // allowProcess = {false}
                                                                        // start for image editor
                                                                        allowReorder={true}
                                                                        // imageEditInstantEdit = {true}
                                                                        onpreparefile={(file, output) => {
                                                                            // console.log("prepare file", file.getMetadata());
                                                                            // console.log("prepare", output);
                                                                            const img = document.createElement("img");
                                                                            img.src = URL.createObjectURL(output);
                                                                            // document.body.appendChild(img);
                                                                        }}
                                                                        imageResizeUpscale={false}
                                                                        imageResizeMode={"contain"}
                                                                        imageEditIconEdit='<svg width="26" height="26" viewBox="0 0 26 26" 
                                                                  xmlns="http://www.w3.org/2000/svg">
                                                                  <path d="M8.5 17h1.586l7-7L15.5 8.414l-7 7V17zm-1.707-2.707l8-8a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-8 8A1 1 0 0 1 10.5 19h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707z"
                                                                   fill="blue" fill-rule="nonzero" stroke="blue" stroke-width="2"></path></svg>'
                                                                        imageEditEditor={create({
                                                                            onconfirm: () => {
                                                                                setHideButton(true)
                                                                            },
                                                                            cropMinImageWidth: 128,
                                                                            cropMinImageHeight: 128
                                                                        })}
                                                                        // end for image editor
                                                                        server={{
                                                                            // fake server to simulate loading a 'local' server file and processing a file
                                                                            process: (fieldName, file, metadata, load) => {
                                                                                // simulates uploading a file
                                                                                setTimeout(() => {
                                                                                    load(Date.now())
                                                                                    fileHandle(file)
                                                                                    // handleImageChange(file)
                                                                                }, 1000);
                                                                            },
                                                                            load: (source, load) => {
                                                                                // simulates loading a file from the server
                                                                                fetch(source).then(res => res.blob()).then(load);
                                                                            }
                                                                        }}
                                                                    >

                                                                    </FilePond>
                                                                </div>
                                                                : chat === 2 ?
                                                                    <div>
                                                                        <button style={{ backgroundColor: 'transparent', border: '0', float: "right" }} type="button" onClick={() => handleChatClose()} className="d-flex align-items-right" ><i class="mdi mdi-close text-black"></i></button>

                                                                        <FilePond
                                                                            allowFileTypeValidation={true}
                                                                            fileValidateTypeLabelExpectedTypes={['allTypes']}
                                                                            allowMultiple={true}
                                                                            maxFiles={1}
                                                                            instantUpload={false}
                                                                            files={[copyfile]}
                                                                            storeAsFile={true}
                                                                            // eslint-disable-next-line
                                                                            credits={"", ""}
                                                                            // allowProcess = {false}
                                                                            onaddfilestart={(file) => {
                                                                                handleDoc(file)
                                                                                setHideButton(true)
                                                                            }}
                                                                            // start for image editor
                                                                            allowReorder={true}
                                                                            onpreparefile={(file, output) => {
                                                                                // console.log("prepare file", file.getMetadata());
                                                                                // console.log("prepare", output);
                                                                                const img = document.createElement("img");
                                                                                img.src = URL.createObjectURL(output);
                                                                                // document.body.appendChild(img);
                                                                            }}
                                                                            imageResizeUpscale={false}
                                                                            imageResizeMode={"contain"}
                                                                            imageEditIconEdit='<svg width="26" height="26" viewBox="0 0 26 26" 
                                                                  xmlns="http://www.w3.org/2000/svg">
                                                                  <path d="M8.5 17h1.586l7-7L15.5 8.414l-7 7V17zm-1.707-2.707l8-8a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-8 8A1 1 0 0 1 10.5 19h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707z"
                                                                   fill="blue" fill-rule="nonzero" stroke="blue" stroke-width="2"></path></svg>'
                                                                            imageEditEditor={create({
                                                                                onconfirm: () => {
                                                                                    setHideButton(true)
                                                                                },
                                                                                cropMinImageWidth: 128,
                                                                                cropMinImageHeight: 128
                                                                            })}
                                                                            // end for image editor
                                                                            server={{
                                                                                // fake server to simulate loading a 'local' server file and processing a file
                                                                                process: (fieldName, files, metadata, load) => {
                                                                                    // simulates uploading a file
                                                                                    setTimeout(() => {
                                                                                        load(Date.now())
                                                                                        fileHandle(files)
                                                                                        // handleImageChange(file) 
                                                                                    }, 1000);
                                                                                },
                                                                                load: (files, load) => {
                                                                                    // simulates loading a file from the server
                                                                                    fetch(files).then(res => res.blob()).then(load);
                                                                                }
                                                                            }}
                                                                        >
                                                                        </FilePond>
                                                                    </div>
                                                                    : ""}
                                                        </form>
                                                        {handleHover &&
                                                            <div className=" col-md-9" style={{ backgroundColor: "#eee", borderRadius: '7px', marginBottom: "3px", paddingBottom: "2px" }}>
                                                                <button style={{ backgroundColor: 'transparent', border: '0', marginLeft: "89%" }} type="button" onClick={handleMouseOut} className="d-flex align-items-right" data-dismiss="modal"><i className="mdi mdi-close text-black"></i></button>
                                                                <p style={{ color: "green", marginLeft: "16px", marginTop: "-29px" }}>{commentDetails.username}</p>
                                                                <p style={{ marginLeft: "16px" }}>
                                                                    {commentDetails.path ?
                                                                        commentDetails.path.substr(commentDetails.path.length - 4) === "blob" && commentDetails.message.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                            // eslint-disable-next-line 
                                                                            <a download={commentDetails.path} className='text-primary' target="_blank" href={commentDetails.path}>
                                                                                <img alt={commentDetails.message} src={commentDetails.path} width="60" height="60" /></a> :
                                                                            !commentDetails.path.match(/.(jpg|jpeg|png|gif)$/i) ?
                                                                                //  eslint-disable-next-line  
                                                                                <a download={commentDetails.message} className='text-primary' target="_blank" href={commentDetails.path}>
                                                                                    {commentDetails.message}</a> :
                                                                                //  eslint-disable-next-line  
                                                                                <a download={commentDetails.path} className='text-primary' target="_blank" href={commentDetails.path}>
                                                                                    <img alt={commentDetails.message} src={commentDetails.path} width="60" height="60" />{commentDetails.message}</a>
                                                                        :
                                                                        <div style={{ whiteSpace: 'break-spaces', overflow: 'auto', maxHeight: '70px' }} dangerouslySetInnerHTML={{ __html: commentDetails.message }}></div>
                                                                    }
                                                                    {/* {commentDetails.message} */}
                                                                </p>
                                                            </div>
                                                        }
                                                        {/* </div> */}
                                                        {
                                                            !hideButtons ?
                                                                <>
                                                                    <div className="row" style={{ display: 'flex', width: '100%' }}>
                                                                        <div style={{ flex: '1' }}>
                                                                            <div style={{ position: 'relative' }}>
                                                                                <textarea
                                                                                    autoFocus
                                                                                    className="form-control copyable-text selectable-text"
                                                                                    ref={textInput}
                                                                                    id="recipient-name document_attachment_doc"
                                                                                    style={{
                                                                                        maxHeight: '200px',
                                                                                        overflowY: 'scroll',
                                                                                        borderColor: 'grey',
                                                                                        borderRadius: '20px',
                                                                                        height: 'auto',
                                                                                        padding: '7px',
                                                                                        width: '100%', // Equal width for textarea
                                                                                    }}
                                                                                    contentEditable="true"
                                                                                    suppressContentEditableWarning={true}
                                                                                    placeholder="Type a message"
                                                                                    onKeyPress={handleKeypress}
                                                                                    value={state.comment}
                                                                                    onChange={(event) => {
                                                                                        handleInputChange(event)

                                                                                    }}
                                                                                    //myPaste={handlePaste}
                                                                                    onPaste={(e) => myPaste(e)}
                                                                                /> {showList && (
                                                                                    <ul style={{
                                                                                        position: 'absolute',
                                                                                        bottom: '100%', // Position it directly top of  the textarea
                                                                                        left: 0,
                                                                                        width: '100%',
                                                                                        margin: 0,
                                                                                        padding: '0',
                                                                                        listStyle: 'none',
                                                                                        border: '1px solid grey',
                                                                                        borderRadius: '4px',
                                                                                        backgroundColor: 'white',
                                                                                        zIndex: 1000,
                                                                                        maxHeight: '250px',
                                                                                        minHeight: '40px',
                                                                                        overflow: 'auto'
                                                                                    }}>
                                                                                        {filteredGroupArray?.filter(data => {
                                                                                            if (props.data.main_task_id !== '0') {
                                                                                                if (props.data.group_task_type === 'Limited') {
                                                                                                    return data.emp_id !== getUser.user.empId && data.emp_id === state.groupList?.assigned_to_id
                                                                                                } else {
                                                                                                    return data.emp_id !== getUser.user.empId

                                                                                                }
                                                                                            } else {
                                                                                                return data.emp_id !== getUser.user.empId
                                                                                            }
                                                                                        }).map((item, index) => (
                                                                                            <li
                                                                                                key={index}
                                                                                                onClick={() => {
                                                                                                    addEmployee(item)
                                                                                                    handleItemClick(item)
                                                                                                }
                                                                                                }
                                                                                                style={{
                                                                                                    padding: '5px',
                                                                                                    cursor: 'pointer',
                                                                                                    borderBottom: index < filteredGroupArray.length - 2 ? '1px solid #ddd' : 'none'
                                                                                                }}
                                                                                            >
                                                                                                {item.full_name}
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ marginRight: '1%', display: 'flex', alignItems: 'center' }}>
                                                                            <div title={ATTACH_FILE} onClick={handleChat}>
                                                                                <img className='chat-send-icons' src="images/common/attachment.svg" alt="Attach File" />
                                                                            </div>
                                                                            <div>
                                                                                <img className='chat-send-icons' src="images/common/video_call.svg" alt="Meet" onClick={() => sendTaskMeetingUrl()} />
                                                                            </div>
                                                                            <div>
                                                                                <button disabled={state.comment.trim() === ""} type="button" style={{ background: 'transparent', border: 'none', padding: '0px' }}>
                                                                                    <img
                                                                                        className='chat-send-icons'
                                                                                        src={state.comment.trim() === "" ? "images/common/send_disable.svg" : "images/common/send.svg"}
                                                                                        alt="Send"
                                                                                        onClick={() => (disable ? undefined : (chat === 1 || chat === 2 ? fileHandle(docFile) : sendMessage()))}
                                                                                    />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        errorMessage !== null ?
                                                                            <label className='text-danger'>{errorMessage}</label>
                                                                            :
                                                                            null
                                                                    }
                                                                </>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>

                                                {/* <div class="modal-footer m-1">
                                
                                    <input type="text" class="form-control col-10 " id="recipient-name" style={{ borderColor: 'grey', borderRadius: '20px' }} 
                                     value={state.comment} onChange={(event) => dispatch(actions.comment(event.target.value))} onKeyPress={handleKeypress}/>
                                    <button type="submit" class="btn btn-outline-success" style={{ borderRadius: '20px' }} onClick={() => sendMessage()}>Send</button>
                                  
                                </div> */}
                                            </>
                                        }
                                        {/* {
                                            meetOpen &&
                                            <JitsiComponent open={meetOpen} roomName={props.data.id} handleClose={(data) => setMeetOpen(false)} updateMeetingUrl={(url) => setMeetingUrl(url)} handleMeetingEnd={() => endMeeting()} />
                                        } */}
                                    </div>
                                </div>
                            </div>
                        </Resizable>
                    </Draggable>
                </Fade>
            </Modal>
            {delegateOpen && delegateCardInfo && (
                <DelegateTask 
                    open={delegateOpen} 
                    handleClose={handleDelegateClose} 
                    data={delegateCardInfo} 
                    handleModalClose={handleDelegateClose}
                />
            )}
        </div >
    );
})
